import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// routes
import Router from './routes';
// The single source of truth for palette / typography / MuiButton
// variants now lives in src/theme.js and is wired at the root in
// src/index.js. The legacy `src/theme/index.js` ThemeProvider is
// unused — its GlobalStyles module is imported here directly so we
// keep the html/body reset and the input[number] spinner hiding.
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/scroll-to-top';
import AutoScrollError from './components/AutoScrollError';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <>
      <GlobalStyles />
      <ScrollToTop />
      <AutoScrollError />
      <Router />
      <ToastContainer
        position="top-right"
        autoClose={1000}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
